import {
  PLIC_PHOTOS_EXPORT_START,
  PLIC_PHOTOS_EXPORT_COMPLETE,
  PLIC_PHOTOS_EXPORT_PROGRESS,
} from './plic-books-actions';

export const initialState = {
  interval: null,
  exportedPhotosCount: 0,
  pendingPhotosCount: 0,
  completed: false,
};

const plicBooksReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case PLIC_PHOTOS_EXPORT_START: {
      // We will have stated a new interval from the action manager.
      // So clear out this one.
      if (state.interval) {
        clearInterval(state.interval);
      }

      return {
        pendingPhotosCount: 0,
        ...state,
        interval: action.interval,
        exportedPhotosCount: state.completed
          ? action.exportedPhotosCount
          : state.exportedPhotosCount + action.exportedPhotosCount,
        completed: false,
      };
    }

    case PLIC_PHOTOS_EXPORT_PROGRESS:
      return {
        ...state,
        pendingPhotosCount: action.pendingPhotosCount,
      };

    case PLIC_PHOTOS_EXPORT_COMPLETE: {
      clearInterval(state.interval);

      return {
        ...state,
        completed: true,
      };
    }

    default:
      return state;
  }
};

export default plicBooksReducer;
